module.exports = __webpack_public_path__ + "static/images/components/UpdateButton/images/update-icon.5276b5be.png";


//////////////////
// WEBPACK FOOTER
// ./components/UpdateButton/images/update-icon.png
// module id = 2679
// module chunks = 11